import { pick } from 'lodash';
import appConstants from '../../../../../appConstants';
import { fetchDispatchStaticData } from '../../../../../utilities/fetchData';
import { RMAXLogger } from '../../../../../services/LoggerService/RMAXLogger';

const getFormattedProDetails = ({ stopData, proId, driverRouteDetails }) => {
  return {
    stopData,
    proData: getProData(stopData, proId),
    driverData: getDriverRoutesData(driverRouteDetails)
  };
};

const getProData = (stopData, proId) => {
  return stopData.shipments?.find((shipment) => shipment.proId === proId);
};

const getDriverRoutesData = (driverDetails) => {
  return pick(driverDetails, [
    "driverId",
    "driverName",
    "driverNumber",
    "manifestNumber",
    "trailerNumber",
    "tractorNumber",
    "routeId",
    "stops",
    "terminalCode"
  ])
};

const getFormattedValue = (value) => {
  return value ?? '-';
};

const getDeliveryShipmentStatusFromDelCode = (delCode) => {
  switch (delCode) {
    case appConstants.DELIVERY_CODE.RTN:
      return appConstants.DELIVERY_STATUS.RETURN;
    case appConstants.DELIVERY_CODE.DE:
      return appConstants.DELIVERY_STATUS.DELIVERY_EXCEPTION;
    case appConstants.DELIVERY_CODE.TA:
      return appConstants.DELIVERY_STATUS.TENDERED_TO_AGENT;
    default:
      return appConstants.DELIVERY_STATUS.DELIVERED_CLEAR;
  }
};

const fetchAndSetStaticData = async ({ DispatchStore, userProfile }) => {
  if (!DispatchStore.staticClientData) {
    try {
      const [clientCodes, hazmatInfo] = await fetchDispatchStaticData(userProfile.terminal.code);
      if (clientCodes.status === 200) {
        const { packageCodes, ...otherClientCodes } = clientCodes.data;
        DispatchStore.setStaticClientData({
          clientCodes: otherClientCodes,
          packageCodes: packageCodes
        });
      }
      if (hazmatInfo.status === 200) {
        DispatchStore.setHazmatInfo(hazmatInfo.data);
      }
    } catch (error) {
      RMAXLogger.error('Error fetching static data:', error);
    }
  }
};

const getFormattedShipperDetailsData = (proData) => {
  return [
    [
      { label: 'Shipper #', value: proData.shipperNumber },
      { label: 'Bill #', value: proData.bolNumber },
      { label: 'PO #', value: proData.poNumber }
    ],
    [
      { label: 'Origin - Destination', value: `${proData?.origin || ''} - ${proData?.destination || ''}` },
      { label: 'Pick-up Date', value: proData.pickupDate },
      { label: 'Terms #', value: proData.billingTerms }
    ]
  ];
};

export {
  getFormattedProDetails,
  getFormattedValue,
  getDeliveryShipmentStatusFromDelCode,
  fetchAndSetStaticData,
  getFormattedShipperDetailsData
};
